// import { randomHexColorWithArray } from 'random-hex-color-generator';
// import React, { useEffect, useState } from 'react';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';

function ReturnRatioGraph({ returnRatioData }) {
    // const [colors, setColors] = useState([]);

    // useEffect(() => {
    //     const colorsArray = randomHexColorWithArray(returnRatioData.length);
    //     setColors(colorsArray);
    // }, [returnRatioData]);

    return (
        <div className="border-[1px] rounded-lg border-[#EAEAEA] col-span-2 min-h-[50vh] p-5 flex flex-col gap-4">
            <div className="chart-data">
                <h1 className="font-urbanist-regular font-semibold text-[16px] leading-6">Return Ratio</h1>
            </div>

            <div className="m-auto">
                <h1 className='font-urbanist-regular font-normal italic text-base text-[#666666]'>Available soon</h1>
            </div>

            {/* <ResponsiveContainer width="100%" height="100%">
                <BarChart width={150} height={40} data={returnRatioData}>
                    <XAxis 
                        dataKey="name" 
                        tickLine={false} 
                        tickMargin={15} 
                        type='category' 
                    />

                    <YAxis 
                        tickCount={6} 
                        tickLine={false} 
                        tickMargin={15} 
                        type="number" 
                        unit={'%'} 
                        domain={[0, 100]} 
                    />
                    
                    <Tooltip 
                        cursor={{ fill: 'transparent' }}
                    />
                    
                    <Bar
                        dataKey="percentage"
                        fill="#00a0fc" 
                        barSize={150} 
                    >
                        {
                            returnRatioData.map((entry, index) => (
                                <Cell 
                                    key={`cell-${index}`} 
                                    fill={colors[index % 20]} 
                                />
                            ))
                        }
                    </Bar>
                </BarChart>
            </ResponsiveContainer> */}
        </div>
    );
}

export default ReturnRatioGraph;
